var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5H19.5C19.8034 5.00023 20.1026 5.06951 20.3752 5.20251C20.6479 5.33552 20.8868 5.52882 21.0737 5.76776C21.2606 6.0067 21.3906 6.28501 21.4541 6.58167C21.5176 6.87832 21.5127 7.18554 21.4399 7.48004L20.4399 13.48C20.3327 13.9136 20.0835 14.2989 19.7319 14.5743C19.3803 14.8498 18.9467 14.9997 18.5 15H6.5C5.96957 15 5.46077 14.7893 5.08569 14.4142C4.71062 14.0392 4.5 13.5304 4.5 13V5C4.5 4.46957 4.28914 3.96089 3.91406 3.58582C3.53899 3.21074 3.03043 3 2.5 3H1.5",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5H19.5C19.8034 5.00023 20.1026 5.06951 20.3752 5.20251C20.6479 5.33552 20.8868 5.52882 21.0737 5.76776C21.2606 6.0067 21.3906 6.28501 21.4541 6.58167C21.5176 6.87832 21.5127 7.18554 21.4399 7.48004L20.4399 13.48C20.3327 13.9136 20.0835 14.2989 19.7319 14.5743C19.3803 14.8498 18.9467 14.9997 18.5 15H6.5C5.96957 15 5.46077 14.7893 5.08569 14.4142C4.71062 14.0392 4.5 13.5304 4.5 13V5ZM4.5 5C4.5 4.46957 4.28914 3.96089 3.91406 3.58582C3.53899 3.21074 3.03043 3 2.5 3H1.5",
    stroke: "#C5C5C5",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 20C6.5 19.4477 6.94772 19 7.5 19C8.05229 19 8.50001 19.4477 8.50001 20C8.50001 20.5523 8.05229 21 7.5 21C6.94772 21 6.5 20.5523 6.5 20ZM7.5 17C5.84315 17 4.5 18.3431 4.5 20C4.5 21.6569 5.84315 23 7.5 23C9.15685 23 10.5 21.6569 10.5 20C10.5 18.3431 9.15685 17 7.5 17ZM16.5 20C16.5 19.4477 16.9477 19 17.5 19C18.0523 19 18.5 19.4477 18.5 20C18.5 20.5523 18.0523 21 17.5 21C16.9477 21 16.5 20.5523 16.5 20ZM17.5 17C15.8431 17 14.5 18.3431 14.5 20C14.5 21.6569 15.8431 23 17.5 23C19.1569 23 20.5 21.6569 20.5 20C20.5 18.3431 19.1569 17 17.5 17Z",
    fill: "#C5C5C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartGray);
export default __webpack_public_path__ + "static/media/cartGray.927696be2803ec1de23dd6788da1bd85.svg";
export { ForwardRef as ReactComponent };